<template>
  <div style="" class="father">
    <!-- 搜索框区域 -->
    <div class="condition">
      <el-form
        :model="swift_data"
        label-position="left"
        label-width="100px"
        class="condition"
      >
        <el-form-item label="商户号："
          ><el-input
            size="mini"
            type="input"
            placeholder="请输入商户号"
            v-model="swift_data.mch_no"
          >
          </el-input
        ></el-form-item>
        <el-form-item label="商户名称："
          ><el-input
            size="mini"
            type="input"
            placeholder="请输入商户名称"
            v-model="swift_data.mch_name"
          >
          </el-input
        ></el-form-item>
        <el-form-item label="商户简称："
          ><el-input
            size="mini"
            type="input"
            placeholder="请输入商户简称"
            v-model="swift_data.sub_name"
          >
          </el-input
        ></el-form-item>
        <el-form-item
          ><el-button
            @click="searchSwifShoptList"
            type="primary"
            size="mini"
            style="margin-right:20px"
          >
            搜索商户
          </el-button></el-form-item
        >
      </el-form>
    </div>
    <!-- 表格区域 -->
    <div style="width:100%" v-if="wtytableshow">
      <wty-table
        ref="wtyTableRef"
        :who="'swiftConfigure'"
        :operate="'查看详情'"
        :wtycolumnList="tableClumn"
        :wtytbheigh="`${scroll_height}px`"
        :wtytbList="swiftShopList"
        @deleteRow="deleteRow"
        @wtyTbreturn="wtyTbreturn"
        @updatePromiss="updatePromiss"
      ></wty-table>
    </div>
    <el-dialog
      title="店铺详情"
      :visible.sync="centerDialogVisible"
      width="35%"
      center
    >
      <div class="form">
        <el-scrollbar wrapStyle="height: 350px;overflow-x:hidden;" style="">
          <div
            class="form-item"
            v-for="(item, index) in swift_Column"
            :style="
              item.label == 'private_key' || item.label == 'public_key'
                ? 'height:100px'
                : ''
            "
            :key="index"
          >
            <div class="label">{{ item.label }}</div>
            <!-- mch_type 1-收费商户 0-免费商户 -->
            <div class="value" v-if="item.value == 'mch_type'">
              {{ swift_detail[item.value] == "1" ? "收费商户" : "免费商户" }}
            </div>

            <div class="value" v-else>{{ swift_detail[item.value] }}</div>
          </div>
        </el-scrollbar>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="centerDialogVisible = false"
          >确 定</el-button
        >
      </span> -->
    </el-dialog>
  </div>
</template>
<script>
import { swiftGetList, swiftQuery } from "@/api/v2/swiftpass.js";
import wtyTable from "@/components/wty-table";
// import swift from "@/components/swift.vue";
//  swift,
export default {
  name: "swiftConfigure",
  components: {
    wtyTable
  },
  data() {
    return {
      centerDialogVisible: false, //是否显示详情
      //表格列
      tableClumn: [
        {
          prop: "mch_no",
          align: "center",
          label: "商户号",
          width: "200"
        },
        {
          prop: "mch_name",
          align: "center",
          label: "商户名称",
          width: "200"
        },
        {
          prop: "sub_name",
          align: "center",
          label: "商户简称",
          width: "200"
        },
        {
          prop: "mch_type",
          align: "center",
          label: "商户类型",
          width: "200"
        },
        {
          prop: "remark",
          align: "left",
          label: "商户简介",
          width: "400"
        }
      ],
      allSwiftShopList: [],
      swiftShopList: [], //所有威富通商户（表格数据）
      scroll_height: "", //表格的高度
      swift_data: {
        //用来搜索威富通商户信息
        mch_no: "",
        sub_name: "",
        mch_name: ""
      },
      swift_Column: [
        {
          label: "md5：",
          value: "md5"
        },
        {
          label: "商户号：",
          value: "mch_no"
        },
        {
          label: "商户名称：",
          value: "mch_name"
        },
        {
          label: "商户简称：",
          value: "sub_name"
        },
        {
          label: "商户类型：",
          value: "mch_type"
        },
        {
          label: "密码：",
          value: "pass_word"
        },
        {
          label: "商户公钥：",
          value: "public_key"
        },
        {
          label: "商户私钥：",
          value: "private_key"
        },
        {
          label: "商户备注：",
          value: "remark"
        }
      ],
      swift_detail: {
        md5: "",
        mch_no: "",
        sub_name: "",
        pass_word: "",
        mch_name: "",
        private_key: "", //私钥
        public_key: "", //公钥
        /**
         * @type {1|0} mch_type 1-收费商户 0-免费商户
         */
        mch_type: "1",
        remark: "" //备注
      },
      wtytableshow: true
    };
  },
  watch: {
    innerWH: {
      handler(newinner, oldinner) {
        if (newinner.innerHeight < 700) {
          this.scroll_height = newinner.innerHeight - 180;
        } else {
          this.scroll_height = newinner.innerHeight - 210;
        }
      },
      deep: true,
      immediate: true
    },

    search_value: {
      handler(newvr, oldv) {
        this.search();
      }
    }
  },
  computed: {
    innerWH() {
      return this.$store.state.resolution.innerWH;
    }
  },
  async mounted() {
    // this.swiftShopList = await swiftGetList();
    this.allSwiftShopList = await swiftGetList();
    /**
     * 获取所有威富通店铺
     */
    this.wtytableshow = false;

    this.$refs.wtyTableRef.setpeopleList(this.allSwiftShopList);
    this.wtytableshow = true;
  },
  methods: {
    searchSwifShoptList() {
      const all = this.allSwiftShopList;
      let list = all;
      if (this.swift_data.mch_no && this.swift_data.mch_no.length > 0) {
        list = list.filter((item, index) => {
          return item.mch_no.indexOf(this.swift_data.mch_no) > -1;
        });
      }
      if (this.swift_data.mch_name && this.swift_data.mch_name.length > 0) {
        list = list.filter((item, index) => {
          return item.mch_name.indexOf(this.swift_data.mch_name) > -1;
        });
      }
      if (this.swift_data.sub_name && this.swift_data.sub_name.length > 0) {
        list = list.filter((item, index) => {
          return item.sub_name.indexOf(this.swift_data.sub_name) > -1;
        });
      }
      if (
        this.swift_data.mch_no == "" &&
        this.swift_data.mch_name == "" &&
        this.swift_data.sub_name == ""
      )
        this.wtytableshow = false;
      this.$refs.wtyTableRef.setpeopleList(list);
      this.wtytableshow = true;
    },
    deleteRow() {},
    /**
     * 点击操作按钮
     */
    async wtyTbreturn(item) {
      const mch_no = item.mch_no;
      const pass_word = item.pass_word;
      // if(this.searchVlaue==""||this.searchVlaue.length==0){
      const ps = await this.$encrypt(this.$md5(pass_word).toUpperCase());
      const res = await swiftQuery(mch_no, ps);
      if (
        res.data.return_code == "SUCCESS" &&
        res.data.result_code == "SUCCESS"
      ) {
        this.centerDialogVisible = true;
        this.swift_detail = res.data.resp_data;
        if (this.swift_data.pass_word)
          this.swift_detail.pass_word = this.swift_data.pass_word;
      }
    },
    /**
     * swift组件修改或者是添加商户，重新获取一下
     */
    async swiftEmit() {
      this.$refs.wtyTableRef.setpeopleList(await swiftGetList());
    },
    /**
     * wty-table 组件选中某一行触发的事件
     */
    updatePromiss() {}
    /* async getSwiftList() {
      return ;
    } */
  }
};
</script>
<style scoped lang="less">
.father {
  width: 100%;
  height: 100%;
  position: relative;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  // justify-content: left;
  padding: 10px;
}
.form {
  .form-item {
    height: auto;
    min-height: 40px;
    width: 100%;
    font-size: 20px;
    display: flex;
    justify-content: left;
    align-items: center;
    .label {
      width: 150px;
      height: 100%;
      display: flex;
      justify-content: left;
      align-items: center;
      font-weight: 700;
      color: #409eff;
    }
    .value {
      width: 90%;
      height: 100%;
      display: flex;
      justify-content: left;
      align-items: center;
    }
  }
}
.condition {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: space-between;
}
</style>
